import * as angular from "angular";
import jsonSchemaForm from "../../../../../../extensions/json-schema/json-schema-form";
import template from "./entity-schema-tab.html";
import "./entity-schema-tab.less";

export default angular.module("vesl.components.entity-schema-tab", [jsonSchemaForm])
	.component("entitySchemaTab", {
		template,
		bindings: {
			schema: "<",
			model: "=",
			formControl: "=?",
			validationResult: "="
		}
	})
	.name;
